import script from "./OrderConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./OrderConfirm.vue?vue&type=style&index=0&id=39c05dc2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c05dc2"]])

export default __exports__